import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../Router/all_routes";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import TableTop from "../../Components/UI/TableTop";
import { useTableSearch } from "../../core/Operations/useTableSearch";
import { useGetEmployeeQuery } from "../../AppQuries/employee/employee_list";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  Edit,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { Download, Eye, Lock, Unlock, Upload, Users } from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { format } from "date-fns";
import Error404 from "../ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import useTableExport from "core/Operations/useTableExport";
import { Select, Spin } from "antd";
import Table from "core/pagination/datatable";
import {
  useResetDeviceMutation,
  useUpdateEmployeeLockStatusMutation,
  useUpdateEmployeePasswordMutation,
} from "AppQuries/employee/emp-login";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import {
  useFormattedDepartmentOption,
  useFormattedEmploymentTypeOption,
  useFormattedEmpTypeOption,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { base_path } from "environment";
import LimitationAlert from "Components/UI/LimiitationAlert";
import { accessCodes } from "core/json/accessCode";
import Can from "core/Operations/Can";
import { useDeleteEmployeeMutation } from "AppQuries/employee/delete-employee";
const EmployeesList = () => {
  const userData = useSelector(loggedInUser);
  const route = all_routes;

  // const [searchParams] = useSearchParams();

  const [queryParams, setQueryParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      groupCode: params.get("groupCode") || 0,
      residentialType: params.get("residentialType") || "",
      departmentCode: params.get("departmentCode") || 0,
      gender: params.get("gender") || "",
      nationality: params.get("nationality") || "",
      employmentType: params.get("employmentType") || "",
      employeeType: params.get("employeeType") || "",
    };
  });

  const [showAll, setShowAll] = useState(false);

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);
  const employeeTypeOptions = useFormattedEmpTypeOption(userData?.companyCode);
  const { mutate: resetDevice } = useResetDeviceMutation();
  const { mutate: updateLoginPermission } =
    useUpdateEmployeeLockStatusMutation();
  const { mutate: updateEmpPassword } = useUpdateEmployeePasswordMutation();
  const { mutate: deleteEmployee } = useDeleteEmployeeMutation();

  const {
    data: employeeData,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getEmployees,
  } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isAllCompanies: userData?.isAllCompanies,
    userId: userData?.userID,
    selectedCompanyCode: userData?.selectedCompanyCode,
    ...queryParams,
  });

  const employeeFields = employeeData?.length
    ? Object.keys(employeeData[0]).map((key) => ({
        title: key,
        dataIndex: key,
      }))
    : [];

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = ({ title, text }) => {
    return MySwal.fire({
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    });
  };

  const handleLoginPermission = async (record) => {
    const result = await showConfirmationAlert({
      title: "Login Permission",
      text: `Are you sure you want to ${
        record.isLock ? "unlock" : "lock"
      } login permission for this employee?`,
    });
    if (result.isConfirmed) {
      const payload = {
        companyCode: record.companyCode,
        employeeID: record.employeeCode,
        updatedUser: userData?.userName,
        updatedDate: getCurrentFormattedDate(),
        isLock: !record.isLock,
      };

      updateLoginPermission(payload, {
        onSuccess: (data) => {
          if (data?.response) {
            MySwal.fire({
              title: "Success",
              text: `Employee login permission has been ${
                record.isLock ? "unlocked" : "locked"
              } successfully.`,
              icon: "success",
            });
            const index = employeeData.findIndex(
              (emp) => emp.employeeCode === record.employeeCode,
            );
            if (index !== -1) {
              employeeData[index].isLock = !record.isLock;
            }
          } else {
            MySwal.fire({
              title: "Error",
              text: `Failed to update login permission: ${data?.errorMessage}`,
              icon: "error",
            });
          }
        },
        onError: (error) => {
          MySwal.fire({
            title: "Error",
            text: `Failed to update login permission: ${error.message}`,
            icon: "error",
          });
        },
      });
      // updateLoginPermission({
    } else {
      MySwal.close();
    }
  };

  const handleResetDeviceToken = async (record) => {
    const result = await showConfirmationAlert({
      title: "Reset Device",
      text: `Are you sure you want to reset device for this employee?`,
    });
    if (result.isConfirmed) {
      const payload = {
        companyCode: record.companyCode,
        employeeID: record.employeeCode,
        userName: userData?.userName,
        currentUserRole: userData?.userGroupCode,
      };

      resetDevice(payload, {
        onSuccess: (data) => {
          if (data?.response) {
            MySwal.fire({
              title: "Success",
              text: `Employee Device has been reset successfully.`,
              icon: "success",
            });
          } else {
            MySwal.fire({
              title: "Error",
              text: `Failed to update device token : ${data?.errorMessage}`,
              icon: "error",
            });
          }
        },
        onError: (error) => {
          MySwal.fire({
            title: "Error",
            text: `Failed to update login permission: ${error.message}`,
            icon: "error",
          });
        },
      });

      MySwal.fire({
        title: "Success",
        text: `Employee device has been reset successfully.`,
        icon: "success",
      });
    }
  };

  const confirmDelete = async (companyCode, employeeCode) => {
    const result = await showConfirmationAlert({
      title: "Delete Employee",
      text: `Are you sure you want to delete this employee?`,
    });
    if (result.isConfirmed) {
      // Call delete API here
      deleteEmployee(
        { companyCode: companyCode, Code: employeeCode },
        {
          onSuccess: (data) => {
            if (data) {
              MySwal.fire({
                title: "Success",
                text: `Employee has been deleted successfully.`,
                icon: "success",
              });
              getEmployees();
            } else {
              MySwal.fire({
                title: "Error",
                text: `Failed to delete employee: ${data?.errorMessage}`,
                icon: "error",
              });
            }
          },
          onError: (error) => {
            MySwal.fire({
              title: "Error",
              text: `Failed to delete employee: ${error.message}`,
              icon: "error",
            });
          },
        },
      );
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "employeePhotoStr",
      width: 100,
      render: (text, record) => (
        <div className="">
          {record?.employeePhotoStr === "" ||
          record?.employeePhotoStr === null ? (
            // <Link to="#" className="">
            <ImagePreview
              src={
                record?.gender === "M"
                  ? base_path + "assets/img/profiles/men.png"
                  : record?.gender === "F"
                    ? base_path + "assets/img/profiles/women.png"
                    : base_path + "assets/img/profiles/men.png"
              }
              alt="Employee Image"
            />
          ) : (
            // <ImageWithBasePath
            //   alt=""
            //   src={
            //     record?.gender === "M"
            //       ? "assets/img/profiles/men.png"
            //       : record?.gender === "F"
            //       ? "assets/img/profiles/women.png"
            //       : "assets/img/profiles/men.png"
            //   }
            //   width={60}
            // />
            // </Link>
            <ImagePreview
              src={record?.imageFilePath || record?.employeePhotoStr}
              alt={record.uniqueId}
            />
          )}
        </div>
      ),
    },
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
      // width: 100,
    },
    {
      title: "Fullname",
      dataIndex: "fullName",
      fixed: "left",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      // width: 300,
      render: (text, record) => (
        <Link
          className="me-2 p-2"
          to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
        >
          {record.fullName}
        </Link>
      ),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      width: 100,
      render: (text, record) => (
        <>
          {text === "M" && <div>Male</div>}
          {text === "F" && <div>Female</div>}
          {text === "T" && <div>Trans</div>}
        </>
      ),
      sorter: (a, b) => a.gender.length - b.gender.length,
    },
    {
      title: "Department",
      dataIndex: "departmentname",
      width: 100,
      sorter: (a, b) => a.departmentname.length - b.departmentname.length,
    },
    {
      title: "Salary Type",
      dataIndex: "salaryType",
      // width: 100,
      // sorter: (a, b) => a.designationName.length - b.designationName.length,
    },
    // {
    //   title: "Designation",
    //   dataIndex: "designationName",
    //   sorter: (a, b) => a.designationName.length - b.designationName.length,
    // },
    // {
    //   title: "Group",
    //   dataIndex: "groupName",
    //   width: 100,
    //   sorter: (a, b) => a.groupName.length - b.groupName.length,
    // },
    // {
    //   title: "DOB",
    //   dataIndex: "dob",
    //   sorter: (a, b) => a.dob.length - b.dob.length,
    // },
    // {
    //   title: "Contact no",
    //   dataIndex: "hpno",
    //   width: 100,
    //   sorter: (a, b) => a.hpno.length - b.hpno.length,
    // },

    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   sorter: (a, b) => a.email.length - b.email.length,
    // },

    {
      title: "Nationality",
      dataIndex: "nationality",
      width: 100,
      sorter: (a, b) => a.nationality.length - b.nationality.length,
    },
    // {
    //   title: "Have Pass Details",
    //   dataIndex: "nationality",
    //   render: (text, record) => (
    //     <>
    //       {record.passportNumber ? (
    //         <span className="badges badge-linesuccess">Yes</span>
    //       ) : (
    //         <span className="badges badge-linedanger">No</span>
    //       )}
    //     </>
    //   )   
    //   // width: 100,
    //   // sorter: (a, b) => a.nationality.length - b.nationality.length,
    // },
    // {
    //   title: "Have Passport Details",
    //   dataIndex: "nationality",
    //   render: (text, record) => (
    //     <>
    //       {record.passportNumber ? (
    //         <span className="badges badge-linesuccess">Yes</span>
    //       ) : (
    //         <span className="badges badge-linedanger">No</span>
    //       )}
    //     </>
    //   )  
      // width: 100,
      // sorter: (a, b) => a.nationality.length - b.nationality.length,
    // },

    // {
    //   title: "Employee Type",
    //   dataIndex: "employeeType",
    //   sorter: (a, b) => a.employeeType.length - b.employeeType.length,
    // },
    // {
    //   title: "Designation",
    //   dataIndex: "designation",
    //   sorter: (a, b) => a.designation.length - b.designation.length,
    // },

    {
      title: "Status",
      dataIndex: "isActive",
      width: 100,
      render: (text, record) => (
        <>
          {record.isActive === true && (
            <span className="badges badge-linesuccess">Active</span>
          )}
          {record.isActive === false && (
            <span className="badges badge-linedanger">In Active</span>
          )}
        </>
      ),
    },
    ...(!userData?.isAllCompanies
      ? [
          {
            title: "Action",
            dataIndex: "action",
            render: (_, record) => (
              <div className="text-center">
                <Link
                  className="action-set"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-expanded="true"
                >
                  <i className="fa fa-ellipsis-v" aria-hidden="true" />
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
                      className="dropdown-item"
                      type="button"
                      // onClick={() => openViewModal(record)}
                    >
                      <i data-feather="dollar-sign" className="info-img" />
                      View Employee
                    </Link>
                  </li>
                  <Can
                    accessModule={accessCodes.human_resources}
                    accessCode={accessCodes.employee_directory}
                    accessType="haveEdit"
                  >
                    <li>
                      <Link
                        to={`${route.employee}${route.employee_edit}/${record.employeeCode}`}
                        className="dropdown-item"
                        // onClick={() => openUpdateModal(record)}
                      >
                        <i data-feather="plus-circle" className="info-img" />
                        Edit Employee
                      </Link>
                    </li>
                  </Can>
                  <Can
                    accessModule={accessCodes.human_resources}
                    accessCode={accessCodes.employee_directory}
                    accessType="haveDelete"
                  >
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() =>
                          confirmDelete(
                            record?.companyCode,
                            record?.employeeCode,
                          )
                        }
                      >
                        <i data-feather="trash-2" className="info-img" />
                        Delete Employee
                      </Link>
                    </li>
                  </Can>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => handleLoginPermission(record)}
                    >
                      <i data-feather="download" className="info-img" />
                      Login Permission &nbsp;
                      {record.isLock ? (
                        <Lock className="ms-2" size={14} />
                      ) : (
                        <Unlock className="ms-2" size={14} />
                      )}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => handleResetDeviceToken(record)}
                    >
                      <i data-feather="download" className="info-img" />
                      Reset Device ID
                    </Link>
                  </li>
                  {/* <li>
                  <Link to="#" className="dropdown-item confirm-text mb-0">
                    <i data-feather="trash-2" className="info-img" />
                    Delete Sale
                  </Link>
                </li> */}
                </ul>
              </div>
            ),
            width: 70,
          },
        ]
      : [
          {
            title: "Action",
            dataIndex: "action",
            render: (_, record) => (
              <div className="text-center">
                <Link
                  className="action-set"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-expanded="true"
                >
                  <i className="fa fa-ellipsis-v" aria-hidden="true" />
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
                      className="dropdown-item"
                      type="button"
                      // onClick={() => openViewModal(record)}
                    >
                      <i data-feather="dollar-sign" className="info-img" />
                      View Employee
                    </Link>
                  </li>
                  {/* <Can
                    accessModule={accessCodes.human_resources}
                    accessCode={accessCodes.employee_directory}
                    accessType="haveEdit"
                  >
                    <li>
                      <Link
                        to={`${route.employee}${route.employee_edit}/${record.employeeCode}`}
                        className="dropdown-item"
                        // onClick={() => openUpdateModal(record)}
                      >
                        <i data-feather="plus-circle" className="info-img" />
                        Edit Employee
                      </Link>
                    </li>
                  </Can>
                  <Can
                    accessModule={accessCodes.human_resources}
                    accessCode={accessCodes.employee_directory}
                    accessType="haveDelete"
                  >
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() =>
                          confirmDelete(
                            record?.companyCode,
                            record?.employeeCode,
                          )
                        }
                      >
                        <i data-feather="trash-2" className="info-img" />
                        Delete Employee
                      </Link>
                    </li>
                  </Can> */}
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => handleLoginPermission(record)}
                    >
                      <i data-feather="download" className="info-img" />
                      Login Permission &nbsp;
                      {record.isLock ? (
                        <Lock className="ms-2" size={14} />
                      ) : (
                        <Unlock className="ms-2" size={14} />
                      )}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => handleResetDeviceToken(record)}
                    >
                      <i data-feather="download" className="info-img" />
                      Reset Device ID
                    </Link>
                  </li>
                  {/* <li>
                  <Link to="#" className="dropdown-item confirm-text mb-0">
                    <i data-feather="trash-2" className="info-img" />
                    Delete Sale
                  </Link>
                </li> */}
                </ul>
              </div>
            ),
            width: 70,
          },
        ]),
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    employeeData,
    searchColumns,
  );

  const { onEmployeeExcelDownload } = useTableExport({
    columns: employeeFields,
    data: filteredData,
    fileName: "Employee Details",
    pdfTheme: "",
  });

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employee Directory</h4>
                <h6>Manage employees</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                to={`${route.employee}${route.employee_login_details}`}
                className="btn btn-link  "
              >
                {/* <Rep className="me-2" /> */}
                Login Details
              </Link>
            </div>
            {!userData?.isAllCompanies && (
              <>
                <Can
                  accessModule={accessCodes.human_resources}
                  accessCode={accessCodes.employee_directory}
                  accessType="haveAdd"
                >
                  <div className="page-btn">
                    <Link
                      to={`${route.employee}${route.employee_add}`}
                      className="btn btn-added  "
                    >
                      <PlusCircle className="me-2" />
                      Add Employee
                    </Link>
                  </div>
                </Can>

                <Can
                  accessModule={accessCodes.human_resources}
                  accessCode={accessCodes.employee_directory}
                  accessType="haveAdd"
                >
                  <div className="page-btn">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="add-new-tooltip">Import Employee</Tooltip>
                      }
                    >
                      <Link
                        to={`${all_routes.employee}${all_routes.employee_import}`}
                        className="btn btn-secondary"
                      >
                        <Download className="me-2" />
                        Import Employee
                      </Link>
                    </OverlayTrigger>
                  </div>
                </Can>
              </>
            )}

            <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onEmployeeExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    searchPlaceHolder="Search Employees"
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card filter-card${
                      isFilterVisible ? " visible" : ""
                    }`}
                    id="filter_inputs"
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="col-lg-3 col-sm-6 col-12 mb-3">
                          <div className="form-group d-grid">
                            <div className="form-floating">
                              <Select
                                defaultValue={queryParams.departmentCode || ""}
                                className="form-control"
                                options={departmentOptions}
                                placeholder="Department"
                                onChange={(e) => {
                                  updateQueryParams("departmentCode", e || 0);
                                }}
                                onClear={() => {
                                  updateQueryParams("departmentCode", 0);
                                }}
                                allowClear
                              />
                              <label className="form-label">Department</label>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-3 col-sm-6 col-12 mb-3">
                          <div className="form-group d-grid">
                            <div className="form-floating">
                              <Select
                                className="form-control"
                                options={employeeTypeOptions}
                                placeholder="Employee Type"
                                // value={queryParams.employeeType || ""}
                                onChange={(value) => {
                                  updateQueryParams(
                                    "employeeType",
                                    value || "",
                                  );
                                }}
                                allowClear
                                onClear={() => {
                                  updateQueryParams("employeeType", "");
                                }}
                              />
                              <label className="form-label">
                                Employee Type
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">&nbsp;</label>
                            <Link
                              className="btn btn-filters ms-auto"
                              onClick={getEmployees}
                              type="button"
                            >
                              <i
                                data-feather="search"
                                className="feather-search"
                              />
                              {isFetching ? (
                                <>
                                  <i className="fas fa-spinner fa-spin me-2"></i>
                                  Loading...
                                </>
                              ) : (
                                <>Filter</>
                              )}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="total-employees d-flex mb-3 justify-content-space-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center mb-0">
                      <h6>
                        <Users className="me-2" />
                        Total Employees &nbsp;&nbsp;
                      </h6>
                      <LimitationAlert
                        totalNumber={employeeData?.length || 0}
                        totalAllowed={userData?.companyDetails.noOfEmployees}
                      />
                    </div>

                    <div className="d-flex justify-content-end align-items-center mb-0">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckChecked"
                          checked={showAll}
                          onChange={(e) => setShowAll(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckChecked"
                        >
                          {showAll ? "Show All" : "Active Only"}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Spin spinning={isLoading || isFetching} size="large">
                      <Table
                        className="table  datanew"
                        columns={columns}
                        dataSource={(filteredData || []).filter((emp) =>
                          showAll ? true : emp.isActive === true,
                        )}
                        scroll={{ x: "max-content", y: 600 }}
                        sticky={true}
                        key={(record, index) => index}
                        pagination={true}
                        loading={isLoading || isFetching}
                      />
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeesList;
